import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-873d4f6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nameField" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr" }, null, -1))
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "surnameField" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alt-placeholder" }, "Příjmení", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr" }, null, -1))
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "emailField" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr" }, null, -1))
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "button solidButton",
    type: "submit",
    tabindex: "4"
  }, " Tak kam se hodím? ")
], -1))

import { computed } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import { bool, object, string } from "yup";
import ConsentCheckbox from "./ConsentCheckbox.vue";
import { questions } from "@/questions";
import submitForm from "@/submitForm";
import { getBestFit } from "@/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'FinalForm',
  setup(__props) {

const { VUE_APP_SUBMIT_REDIRECT_URL } = process.env;

const store = useStore();

const { errors, handleSubmit } = useForm({
  validationSchema: object({
    name: string()
      .required("Pole je povinné.")
      .min(5, "Pole musí obsahovat aspoň 5 znaků.")
      .max(50, "Pole musí obsahovat 50 a&nbsp;méně znaků."),
    email: string()
      .required("Pole je povinné.")
      .email("Pole musí obsahovat validní email.")
      .max(50, "Pole musí obsahovat 50 a&nbsp;méně znaků."),
    consent: bool().oneOf([true, false], "Pole musí být označené."),
  }),
  initialValues: {
    name: "",
    surname: "",
    email: "",
    consent: false,
  },
});

const { value: name } = useField<string>("name");
const { value: surname } = useField<string>("surname");
const { value: email } = useField<string>("email");
const { value: consent } = useField<boolean>("consent");

const hideName = computed(() => name.value.length === 0);
const hideEmail = computed(() => email.value.length === 0);

const submit = handleSubmit(() => {
  const answers = store.state.answers;
  const bestFit = getBestFit(store.getters.answers);
  let position = "taxes";
  if (bestFit) {
    position = bestFit[0];
  }
  const answersPayload = questions.map((q, i) => ({
    question: q.question,
    option: answers[i],
  }));
  const payload = {
    name: name.value,
    email: email.value,
    consent: consent.value,
    position: position.toUpperCase(),
    answers: answersPayload,
  };
  submitForm(payload)
    // .then(() => window.open(VUE_APP_SUBMIT_REDIRECT_URL, '_self'))
    // .catch(() => window.open(VUE_APP_SUBMIT_REDIRECT_URL, '_self'))
    // Replace window.open with this line if you want minal "clap" screen again
    .then(() => store.commit("submit"))
    .catch(() => store.commit("submit"));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["alt-placeholder", { hideName: _unref(hideName) }])
      }, " Jméno a příjmení ", 2),
      _withDirectives(_createElementVNode("input", {
        id: "name",
        type: "text",
        placeholder: "Jméno a příjmení",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
        tabindex: "1"
      }, null, 512), [
        [_vModelText, _unref(name)]
      ]),
      _hoisted_2,
      _createElementVNode("div", {
        class: "error",
        innerHTML: _unref(errors).name
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        id: "surname",
        type: "text",
        placeholder: "Příjmení",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(surname) ? (surname).value = $event : null))
      }, null, 512), [
        [_vModelText, _unref(surname)]
      ]),
      _hoisted_6,
      _createElementVNode("div", {
        class: "error",
        innerHTML: _unref(errors).name
      }, null, 8, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: _normalizeClass(["alt-placeholder", { hideEmail: _unref(hideEmail) }])
      }, " E‑mailová adresa ", 2),
      _withDirectives(_createElementVNode("input", {
        id: "email",
        type: "text",
        placeholder: "E‑mailová adresa",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
        tabindex: "2"
      }, null, 512), [
        [_vModelText, _unref(email)]
      ]),
      _hoisted_9,
      _createElementVNode("div", {
        class: "error",
        innerHTML: _unref(errors).email
      }, null, 8, _hoisted_10)
    ]),
    _createElementVNode("div", null, [
      _createVNode(ConsentCheckbox, {
        modelValue: _unref(consent),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(consent) ? (consent).value = $event : null))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", {
        class: "error error-consent",
        innerHTML: _unref(errors).consent
      }, null, 8, _hoisted_11)
    ]),
    _hoisted_12
  ], 32))
}
}

})